module.exports = __webpack_public_path__ + "img/cachoeirapaulista.8c713255.png";